import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { RouterStateSerializer } from "@ngrx/router-store";

import { RouterUrlState } from "./router-url-state";

@Injectable()
export class RouterUrlStateSerializer implements RouterStateSerializer<RouterUrlState> {
	serialize(routerState: RouterStateSnapshot): RouterUrlState {
		const { url } = routerState;
		const { queryParams } = routerState.root;
		let state: ActivatedRouteSnapshot = routerState.root;
		while (state.firstChild) {
			state = state.firstChild;
		}
		const params = state.params;
		return { url, queryParams, params };
	}
}
